import React from 'react'
import AppointmentsSummaryChart from './AppointmentsSummaryChart'
import HourChart from './HourChart'
import BoxMap from './BoxMap'
import { Card, Flex } from 'antd'
import AppointmentEventsChart from './AppointmentEventsChart'
import PostalPlaceFilledChart from './PostalPlaceFilledChart'

export default function SingleBoxCharts (appointments, selectedBox) {
  const groupedCharts = (charts) => (
    <Card>
      <Flex justify='space-around'>
        {charts.map(Chart => <Chart appointments={appointments.filter(appointment => appointment.type === 'PatientAppointment' && appointment.state === 'done')} key={Chart.toString()} />)}
      </Flex>
    </Card>
  )

  return [
    { key: 'appointmentSummary', children: (<AppointmentsSummaryChart appointments={appointments} />) },
    { key: 'appointmentHour', children: (<HourChart appointments={appointments} />) },
    { key: 'boxMap', children: (<BoxMap appointments={appointments.filter(appointment => appointment.type === 'PatientAppointment' && appointment.state === 'done')} selectedBox={selectedBox} />) },
    { key: 'groupedCharts1', children: (groupedCharts([AppointmentEventsChart, PostalPlaceFilledChart])) }
  ]
}
